const articleName = 'Follow this guide to add the DNS records below.'

export const registrars = [
  {
    name: 'GoDaddy',
    articleName: articleName,
    url: 'https://www.godaddy.com/help/manage-dns-records-680?utm_source=chatgpt.com',
    match: (ns) => ns.endsWith('domaincontrol.com')
  },
  {
    name: 'Namecheap',
    articleName: articleName,
    url: 'https://www.namecheap.com/support/knowledgebase/article.aspx/434/2237/how-do-i-set-up-host-records-for-a-domain/?utm_source=chatgpt.com',
    match: (ns) => ns.endsWith('registrar-servers.com')
  },
  {
    name: 'Cloudflare',
    articleName: articleName,
    url: 'https://developers.cloudflare.com/dns/manage-dns-records/how-to/create-dns-records/?utm_source=chatgpt.com',
    match: (ns) =>
      ns.endsWith('ns.cloudflare.com') ||
      ns.endsWith('foundationdns.com') ||
      ns.endsWith('foundationdns.net') ||
      ns.endsWith('foundationdns.org')
  },
  {
    name: 'Squarespace / Google Domains',
    articleName: articleName,
    url: 'https://support.squarespace.com/hc/en-us/articles/360002101888-Adding-DNS-records-to-your-domain?utm_source=chatgpt.com',
    match: (ns) =>
      ns.endsWith('squarespacedns.com') ||
      /^dns\d+\.p\d+\.nsone\.net$/.test(ns) ||
      /^ns-cloud-\w+\.googledomains\.com$/.test(ns)
  },
  {
    name: 'IONOS',
    articleName: articleName,
    url: 'https://www.ionos.com/help/domains/dns-settings/?utm_source=chatgpt.com',
    match: (ns) =>
      ns.endsWith('ui-dns.com') ||
      ns.endsWith('ui-dns.de') ||
      ns.endsWith('ui-dns.biz') ||
      ns.endsWith('ui-dns.org') ||
      ns.includes('ui-global-dns.')
  },
  {
    name: 'Hostinger',
    articleName: articleName,
    url: 'https://www.hostinger.com/support/1583249-how-to-manage-dns-records-at-hostinger/?utm_source=chatgpt.com',
    match: (ns) => ns.endsWith('dns-parking.com')
  },
  {
    name: 'Dynadot',
    articleName: articleName,
    url: 'https://www.dynadot.com/help/question/set-up-DNS?utm_source=chatgpt.com',
    match: (ns) =>
      ns === 'ns1.dynadot.com' ||
      ns === 'ns2.dynadot.com' ||
      (ns.endsWith('dynadot.com') && (ns.startsWith('ns1') || ns.startsWith('ns2')))
  },
  {
    name: 'Porkbun',
    articleName: articleName,
    url: 'https://kb.porkbun.com/article/231-how-to-add-dns-records-on-porkbun?utm_source=chatgpt.com',
    match: (ns) => ns.endsWith('ns.porkbun.com')
  },
  {
    name: 'Network Solutions',
    articleName: articleName,
    url: 'https://www.networksolutions.com/help/article/manage-dns-adns-records?utm_source=chatgpt.com',
    match: (ns) => /^ns\d+\.worldnic\.com$/.test(ns)
  },
  {
    name: 'Bluehost',
    articleName: articleName,
    url: 'https://www.bluehost.com/help/article/dns-management-add-edit-or-delete-dns-entries?utm_source=chatgpt.com',
    match: (ns) => ns === 'ns1.bluehost.com' || ns === 'ns2.bluehost.com'
  },
  {
    name: 'Domain.com',
    articleName: articleName,
    url: 'https://manage.vip.domain.com/kb/servlet/KBServlet/faq471.html?utm_source=chatgpt.com',
    match: (ns) => ns === 'ns1.domain.com' || ns === 'ns2.domain.com'
  },
  {
    name: 'Name.com',
    articleName: articleName,
    url: 'https://www.name.com/support/articles/206127137-adding-dns-records-and-templates?utm_source=chatgpt.com',
    match: (ns) => /^ns[1-4]\.name\.com$/.test(ns)
  },
  {
    name: 'Hover / Tucows',
    articleName: articleName,
    url: 'https://support.hover.com/support/solutions/articles/201000064728-managing-dns-records?utm_source=chatgpt.com',
    match: (ns) => ns === 'ns1.hover.com' || ns === 'ns2.hover.com'
  },
  {
    name: 'Enom / Tucows',
    articleName: articleName,
    url: 'https://support.enom.com/support/solutions/articles/201000065361-managing-dns-host-records?utm_source=chatgpt.com',
    match: (ns) => ns.endsWith('name-services.com')
  },
  {
    name: 'DreamHost',
    articleName: articleName,
    url: 'https://help.dreamhost.com/hc/en-us/articles/360035516812-Adding-custom-DNS-records?utm_source=chatgpt.com',
    match: (ns) => /^ns[1-3]\.dreamhost\.com$/.test(ns)
  },
  {
    name: 'Gname',
    articleName: articleName,
    url: 'https://www.gname.com/help/71.html?utm_source=chatgpt.com',
    match: (ns) => ns.endsWith('gname-dns.com')
  },
  {
    name: 'Wix',
    articleName: articleName,
    url: 'https://support.wix.com/en/article/managing-dns-records-in-your-wix-account?utm_source=chatgpt.com',
    match: (ns) => ns.endsWith('wixdns.net')
  },
  {
    name: 'Shopify',
    articleName: articleName,
    url: 'https://help.shopify.com/en/manual/domains/managing-domains/edit-dns-settings?utm_source=chatgpt.com',
    match: (ns) => ns.endsWith('shopify.com')
  },
  {
    name: 'Alibaba Cloud',
    articleName: articleName,
    url: 'https://www.alibabacloud.com/help/en/dns/pubz-add-remove-manage-domain-names?utm_source=chatgpt.com',
    match: (ns) => ns.endsWith('alidns.com')
  }
]

export const detectRegistrar = (nameServers) => {
  if (!nameServers || !nameServers.length) return null

  for (const registrar of registrars) {
    const isMatch = nameServers.some((ns) => {
      const lowerNs = ns.toLowerCase().replace(/\.$/, '')
      return registrar.match(lowerNs)
    })

    if (isMatch) {
      return {
        registrarName: registrar.name,
        helpArticleUrl: registrar.url,
        helpArticleName: registrar.articleName
      }
    }
  }

  return null
}
